module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/global-sign-e0402f6622d1623377879410c9670d7d.webp";